import React, { useEffect, useState } from "react";

import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import { useQuery } from "react-query";

import {
  handleGetSubscriptionById,
  handleUpdateSubscriptionById,
} from "../../axios";
import { toast } from "react-toastify";

const UpdateSubscription = () => {
  const { user } = useSelector((state) => state.auth);
  const [value, setValue] = useState("");
  const navigate = useNavigate();
  const [selectedStatus, setSelectedStatus] = useState("");

  const { id } = useParams();

  const config = {
    headers: {
      Authorization: "Bearer " + user?.token,
    },
  };

  const { data: subscriptionData, isLoading: loading } = useQuery(
    ["subscription", id],
    () => handleGetSubscriptionById(id),
    { enabled: !!id }
  );

  useEffect(() => {
    setSelectedStatus(
      subscriptionData && subscriptionData?.data?.[0]?.subscription_status
    );
  }, [subscriptionData]);

  const handleStatusChange = async (e) => {
    const newStatus = e.target.value;
    setSelectedStatus(newStatus);
  };
  const updateSubscription = async () => {
    try {
      const res = await handleUpdateSubscriptionById(selectedStatus, id);

      if (res.status === 200) {
        toast.success(res.data.message, {
          position: "top-right",
        });
        navigate("/payments");
      } else {
        toast.error(res.data.error, {
          position: "top-right",
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div>
      <div>
        <p className="font-semibold antialiased tracking-wide text-[22px]">
          Update Subscription
        </p>
      </div>

      <div className="mt-6">
        <select
          value={selectedStatus}
          onChange={handleStatusChange}
          className="ring-2 ring-gray-200 w-[350px] h-10 rounded-[8px]"
        >
          <option value="active">Active</option>
          <option value="cancelled">cancel</option>
          <option value="inactive">In-Active</option>
          <option value="expired">Expired</option>
        </select>

        {subscriptionData?.data?.[0]?.subscription_plan_type !== "free" && (
          <button
            onClick={updateSubscription}
            className="bg-black text-white h-10 w-[130px] rounded-[8px] flex justify-center items-center gap-2 hover:ring-2 hover:ring-gray-300 transition-all duration-300 mt-6"
          >
            <p>Save changes</p>
          </button>
        )}
      </div>
    </div>
  );
};

export default UpdateSubscription;
